export default function Testimonials() {
  const testimonials = [
    {
      name: 'Carlos M.',
      country: 'Chile',
      creditType: 'Crédito Personal',
      amount: '$4,500,000 CLP',
      rating: 5,
      comment: 'El proceso fue claro y rápido. Me asesoraron en todo momento y mi crédito fue aprobado sin complicaciones. Totalmente confiables.',
      image: 'https://public.readdy.ai/ai/img_res/482381e7697b9411d2d3db8803d631d1.jpg'
    },
    {
      name: 'Ana R.',
      country: 'Perú',
      creditType: 'Microcrédito',
      amount: 'S/ 15,000 PEN',
      rating: 5,
      comment: 'Necesitaba capital para mi negocio y Novacréditos me apoyó. Muy profesionales y respetuosos con mis datos.',
      image: 'https://readdy.ai/api/search-image?query=professional%20peruvian%20businesswoman%20entrepreneur%20in%20modern%20workspace%20wearing%20elegant%20business%20attire%20smiling%20warmly%20with%20clean%20simple%20background%20natural%20lighting%20corporate%20photography%20style&width=400&height=400&seq=testimonial-ana-peru&orientation=squarish'
    },
    {
      name: 'Luis R.',
      country: 'México',
      creditType: 'Crédito Hipotecario',
      amount: '$1,200,000 MXN',
      rating: 5,
      comment: 'Excelente atención y seguimiento. La información fue confidencial y el financiamiento aprobado en poco tiempo.',
      image: 'https://readdy.ai/api/search-image?query=professional%20mexican%20businessman%20in%20modern%20corporate%20office%20wearing%20formal%20business%20suit%20smiling%20professionally%20with%20clean%20simple%20background%20natural%20lighting%20corporate%20photography%20style&width=400&height=400&seq=testimonial-luis-mexico&orientation=squarish'
    },
    {
      name: 'Patricia S.',
      country: 'Chile',
      creditType: 'Financiamiento Empresarial',
      amount: '$8,000,000 CLP',
      rating: 5,
      comment: 'Gracias a Novacréditos pude expandir mi empresa. El proceso fue transparente y el equipo muy profesional.',
      image: 'https://readdy.ai/api/search-image?query=professional%20chilean%20businesswoman%20executive%20in%20elegant%20office%20wearing%20business%20formal%20attire%20smiling%20confidently%20with%20clean%20simple%20background%20natural%20lighting%20corporate%20photography%20style&width=400&height=400&seq=testimonial-patricia-chile&orientation=squarish'
    },
    {
      name: 'Roberto M.',
      country: 'Perú',
      creditType: 'Crédito Personal',
      amount: 'S/ 25,000 PEN',
      rating: 5,
      comment: 'Servicio excepcional. Me ayudaron a consolidar mis deudas y ahora tengo una cuota más manejable. Muy recomendados.',
      image: 'https://readdy.ai/api/search-image?query=professional%20peruvian%20businessman%20in%20contemporary%20office%20wearing%20smart%20casual%20business%20attire%20smiling%20genuinely%20with%20clean%20simple%20background%20natural%20lighting%20corporate%20photography%20style&width=400&height=400&seq=testimonial-roberto-peru&orientation=squarish'
    },
    {
      name: 'Carmen L.',
      country: 'México',
      creditType: 'Microcrédito',
      amount: '$180,000 MXN',
      rating: 5,
      comment: 'Rápido, seguro y confiable. Obtuve el capital que necesitaba para mi emprendimiento sin complicaciones.',
      image: 'https://readdy.ai/api/search-image?query=professional%20mexican%20businesswoman%20entrepreneur%20in%20modern%20office%20wearing%20elegant%20business%20casual%20attire%20smiling%20warmly%20with%20clean%20simple%20background%20natural%20lighting%20corporate%20photography%20style&width=400&height=400&seq=testimonial-carmen-mexico&orientation=squarish'
    }
  ];

  const featuredTestimonial = {
    name: 'María G.',
    country: 'México',
    creditType: 'Financiamiento Empresarial',
    amount: '$2,500,000 MXN',
    rating: 5,
    comment: 'Después de buscar opciones en varias instituciones financieras, encontré en Novacréditos la solución perfecta para mi empresa. El proceso fue completamente transparente desde el inicio, me explicaron cada paso con claridad y siempre mantuvieron la confidencialidad de mi información. La evaluación fue rápida y profesional, y en menos de dos semanas ya tenía el financiamiento aprobado. Gracias a este apoyo, pude adquirir el equipo que necesitaba para expandir mi negocio. Sin duda, son una institución seria y confiable que recomiendo ampliamente.',
    image: 'https://readdy.ai/api/search-image?query=professional%20mexican%20businesswoman%20executive%20in%20elegant%20modern%20office%20wearing%20sophisticated%20business%20suit%20smiling%20confidently%20with%20clean%20minimalist%20background%20natural%20lighting%20high%20quality%20corporate%20photography%20style&width=600&height=600&seq=testimonial-maria-featured&orientation=squarish'
  };

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 via-white to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Casos reales de clientes aprobados
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            En Novacréditos, ayudamos a personas y empresas en Chile, Perú y México a acceder a soluciones financieras reales, seguras y transparentes.
          </p>
        </div>

        {/* Featured Testimonial */}
        <div className="mb-16">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
            <div className="grid md:grid-cols-5 gap-8">
              <div className="md:col-span-2 relative h-96 md:h-auto">
                <img 
                  src={featuredTestimonial.image}
                  alt={featuredTestimonial.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="md:col-span-3 p-8 md:p-12 flex flex-col justify-center">
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(featuredTestimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-2xl text-amber-400"></i>
                  ))}
                </div>
                <p className="text-slate-700 text-lg leading-relaxed mb-6 italic">
                  "{featuredTestimonial.comment}"
                </p>
                <div className="flex items-center justify-between flex-wrap gap-4">
                  <div>
                    <h3 className="text-xl font-bold text-slate-800">{featuredTestimonial.name}</h3>
                    <p className="text-emerald-600 font-medium">{featuredTestimonial.country}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-slate-600 font-medium">{featuredTestimonial.creditType}</p>
                    <p className="text-lg font-bold text-slate-800">{featuredTestimonial.amount}</p>
                    <div className="inline-flex items-center space-x-2 mt-2 bg-emerald-50 px-3 py-1 rounded-full">
                      <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                      <span className="text-sm font-semibold text-emerald-700">Crédito Aprobado</span>
                    </div>
                  </div>
                </div>
                <div className="mt-6">
                  <a 
                    href="#more-testimonials" 
                    className="inline-flex items-center space-x-2 text-emerald-600 font-semibold hover:text-emerald-700 transition-colors"
                  >
                    <span>Ver más casos de éxito</span>
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div id="more-testimonials" className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-xl font-bold text-white">{testimonial.name}</h3>
                  <p className="text-emerald-300 font-medium">{testimonial.country}</p>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center space-x-1 mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-lg text-amber-400"></i>
                  ))}
                </div>
                
                <p className="text-slate-600 text-sm leading-relaxed mb-4 italic">
                  "{testimonial.comment}"
                </p>
                
                <div className="border-t border-slate-200 pt-4 space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-xs text-slate-500 font-medium">Tipo de Crédito</span>
                    <span className="text-sm font-semibold text-slate-800">{testimonial.creditType}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-xs text-slate-500 font-medium">Monto</span>
                    <span className="text-sm font-bold text-emerald-600">{testimonial.amount}</span>
                  </div>
                  <div className="flex justify-center pt-2">
                    <div className="inline-flex items-center space-x-2 bg-emerald-50 px-3 py-1 rounded-full">
                      <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                      <span className="text-xs font-semibold text-emerald-700">Crédito Aprobado</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Legal Note */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-start space-x-3 bg-slate-100 rounded-xl px-6 py-4 max-w-3xl">
            <i className="ri-information-line text-2xl text-slate-600 mt-1"></i>
            <p className="text-sm text-slate-600 text-left">
              <strong className="text-slate-800">Nota Legal:</strong> Los testimonios reflejan experiencias reales de clientes. Los resultados pueden variar según evaluación crediticia.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
